import { css } from '@emotion/css';
import userApi from 'apis/userApi';
import logo from 'assets/images/logos/qr.png';
import { colors } from 'constants/theme';
import { AgentRegLinkPayload } from 'models/agentModel';
import QRCode from 'qrcode';
import { useEffect, useRef, useState } from 'react';
import toast from 'react-hot-toast';
import { FaLink } from 'react-icons/fa6';

function AgentRegister() {
    const qrCodeRef = useRef<HTMLDivElement>(null);
    const [, setQrCode] = useState<HTMLCanvasElement | null>(null);
    const [regLink, setRegLink] = useState('');

    useEffect(() => {
        initAgentReg();
    }, []);

    const initAgentReg = async () => {
        try {
            const { data } = await userApi.agentUserAutoRegList({});
            if (!data.msg) {
                const qrCodeData = data.reslist[0];

                if (qrCodeData?.sign) {
                    const linkReg = new URL(qrCodeData.sign);

                    setRegLink(qrCodeData.sign);
                    generateQRCode(data.reslist[0].sign);
                } else {
                    createAgentLink();
                }
            } else {
                toast.error(data.msg);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const generateQRCode = async (link: string) => {
        let canvas = await QRCode.toCanvas(link, { errorCorrectionLevel: 'high', width: 160 });

        //adding a log at center
        const imgDim = { width: 30, height: 30 }; //logo dimention
        var context = canvas.getContext('2d');
        var imageObj = new Image();
        imageObj.src = logo;
        imageObj.onload = function () {
            if (context) {
                context.drawImage(imageObj, canvas.width / 2 - imgDim.width / 2, canvas.height / 2 - imgDim.height / 2, imgDim.width, imgDim.height);
            }
        };
        setQrCode(canvas);
        if (qrCodeRef.current) {
            qrCodeRef.current.appendChild(canvas);
        }
    };

    const copyText = (text: string) => {
        navigator.clipboard.writeText(text);
        toast.success('Sao chép thành công!');
    };

    const createAgentLink = async () => {
        const payload: AgentRegLinkPayload = { rpointssc: 0, rpoint115: 0, rpointdp: 0 };

        try {
            const { data } = await userApi.agentCreateLink(payload);
            if (!data.msg) {
                toast.success('Tạo liên kết thành công');
                initAgentReg();
            } else {
                toast.error(data.msg);
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <>
            <div className={`${styles.wrap}`}>
                <div className={styles.headerNote}>
                    <h6 className={styles.title}>Nhắc nhở</h6>
                    <div className={styles.ruleQr}>
                        <ul>
                            <li>
                                Mỗi hội viên chỉ có <strong>1</strong> liên kết đăng ký.
                            </li>
                            <li>Sau khi thiết lập liên kết đăng ký, nhấp vào [Liên kết], mở cột địa chỉ để hiển thị liên kết đăng ký</li>
                        </ul>
                    </div>
                </div>

                <div className={styles.tableLink}>
                    <div className={styles.table}>
                        <div className="row">
                            <p className="title col">Thứ tự</p>
                            <p className="title col">Thao tác</p>
                        </div>
                        <div className="row">
                            <p className="col">{'1'}</p>
                            <div className="link">
                                <FaLink color="black" onClick={() => copyText(regLink)} />
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    );
}

const styles = {
    tableLink: css`
        background-color: #f2f2f2;
        border-radius: 3px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.35);
        min-height: 250px;
        padding-left: 3px;
        padding-right: 3px;
        padding-top: 3px;
        padding-bottom: 3px;
        margin-bottom: 100px;
    `,
    table: css`
        border-radius: 5px;
        overflow: hidden;
        &.table-col-center {
            .col {
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
        .row {
            display: flex;
            border-bottom: 1px solid var(--border-table);
            background-color: #e2dfdc;
            &:first-child {
                border-bottom-color: white;
            }
            &:last-child {
                border-bottom: none;
            }
        }
        .col {
            flex: 1;
            padding: 12px 8px;
            text-align: center;
            font-size: 12.8px;
            font-weight: 300;
        }
        .link {
            flex: 1;
            padding: 12px 8px;
            justify-content: center;
            align-items: center;
            display: flex;
        }
        .text-left {
            text-align: left;
        }
        .title {
            color: white;
            font-weight: 300;
            border-right: 1px solid white;
            background-color: ${colors.primary};
            &:last-child {
                border-right: 0;
            }
        }
        .no-data {
            text-align: center;
            padding: 30px;
            height: 180px;
            p {
                margin-top: 8px;
                font-size: 14px;
            }
        }
    `,
    headerNote: css`
        padding-left: 50px;
        margin-top: 20px;
    `,
    title: css`
        font-weight: 300;
        color: black;
        font-size: 20px;
        margin-bottom: 20px;
    `,
    wrap: css`
        color: black;
        background-color: white;
        border-radius: 8px;
        padding-top: 20px;
        padding-left: 20px;
        padding-bottom: 20px;
        padding-right: 20px;
    `,
    qrcodeWrap: css`
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 60px;
        padding: 30px;
        background: rgba(0, 0, 0, 0.5);
        border-radius: 8px;
        border: 1px solid ${colors.borderPrimary};
    `,
    qrcodeIcon: css`
        border-radius: 12px;
        overflow: hidden;
        display: flex;
        flex: 0 0 160px;
        max-width: 160px;
    `,
    ruleQr: css`
        margin-bottom: 20px;
        ul {
            padding-left: 32px;
        }
        li {
            margin-bottom: 10px;
            font-size: 15px;
        }
    `,
    generateQr: css`
        padding-left: 32px;
        li {
            margin-bottom: 4px;
        }
        span {
            color: ${colors.red};
            font-weight: 500;
        }
    `,
};

export default AgentRegister;
